/* eslint-disable */
import axios from '../request/http.js'; // 导入http中创建的axios实例
const base = "https://admin.shifangxuan.cn/index.php/";
import VueCookies from 'vue-cookies'


const Api = {
    //post请求
    postData(url,data) {
		let token = "";
		if(VueCookies.get('carwebToken')){
			token = VueCookies.get('carwebToken');
		}
        return axios.post(`${base}${url}`,data,
        {
          headers: {
            'Content-Type': 'application/json',
			"authorization":"carweb "+token
          }
        });
    },
	
	//获取get请求数据
	exportExcel(url,data){
		if(VueCookies.get('carwebToken')){
			data.token = VueCookies.get('carwebToken');
		}
	  return axios({
		  method:"post",
		  url:`${base}${url}`,
		  data:data,
	      responseType: 'blob'
	  });
	},
	exportUrl(){
		return imageBase;
	}
}

export default Api;
